<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_ALLERGIE')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="allergieForm">
            <div class="form-row d-flex align-self-center">
                <span id="allergie-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_ALLERGIE_MEDICAMENT')}}<span
                        class="red-label">*</span></span>
                <div class="col-md-7">
                    <mat-radio-group name="allergie" formControlName="allergie" aria-labelledby="allergie-label">
                        <mat-radio-button value="true">{{texteService.getTexte('LABEL_OUI')}}</mat-radio-button>
                        <mat-radio-button value="false">{{texteService.getTexte('LABEL_NON')}}</mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="allergieForm.controls.allergie.touched && allergieForm.controls.allergie.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="allergie-precision" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_ALLERGIE_PRECISION')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="allergie-precision" matInput type="text" name="precision" formControlName="precision" />
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="allergie-liste-medicament"
                    class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_ALLERGIE_LISTE')}}</label>
                <textarea id="allergie-liste-medicament" class="col-md-7 form-control" formControlName="listeMedicament"></textarea>
            </div>
        </form>
    </mat-card-content>
</mat-card>
